import { forwardRef } from "react";
import Content, { ContentNS } from "content/content";
import { QuietButton } from "features/shared/components/buttons/QuietButton.styled";
import Body from "features/shared/styles/typography/Body.styled";
import Card from "features/document-page/components/passport/styles/Card.styled";
import PassportForm from "features/document-page/components/passport/components/passport-form/PassportForm";

interface ManualPassportInputProps {
  isFormShown: boolean;
  onEnterManuallyClick: () => void;
}

// TODO Den check why forwardRef
const ManualPassportInput = forwardRef<
  HTMLParagraphElement,
  ManualPassportInputProps
>(({ isFormShown, onEnterManuallyClick }, ref) => {
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.passport });

  return (
    <>
      <Body className="manual-info" ref={ref}>
        {text("manual-info")}
      </Body>

      {isFormShown ? (
        <Card>
          <PassportForm />
        </Card>
      ) : (
        <QuietButton onClick={onEnterManuallyClick}>
          {text("manual-button-title")}
        </QuietButton>
      )}
    </>
  );
});

export default ManualPassportInput;
